var map = {
	"./template-1/purchases/purchases": "app/styles/client/templates/template-1/purchases/purchases",
	"./template-10/purchases/purchases": "app/styles/client/templates/template-10/purchases/purchases",
	"./template-11/purchases/purchases": "app/styles/client/templates/template-11/purchases/purchases",
	"./template-2/purchases/purchases": "app/styles/client/templates/template-2/purchases/purchases",
	"./template-3/purchases/purchases": "app/styles/client/templates/template-3/purchases/purchases",
	"./template-4/purchases/purchases": "app/styles/client/templates/template-4/purchases/purchases",
	"./template-5/purchases/purchases": "app/styles/client/templates/template-5/purchases/purchases",
	"./template-6/purchases/purchases": "app/styles/client/templates/template-6/purchases/purchases",
	"./template-7/purchases/purchases": "app/styles/client/templates/template-7/purchases/purchases",
	"./template-8/purchases/purchases": "app/styles/client/templates/template-8/purchases/purchases",
	"./template-9/purchases/purchases": "app/styles/client/templates/template-9/purchases/purchases"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2405;